export const VERSION = "11.0.4";
export const RELEASE = "style-profile@11.0.4";
